export { default } from "bullitttime-embermodelsevent/adapters/mass-start-class-group-association";
